import { TAnonymousSplitTest, TBranch } from './useAnonymousSplitTests';

const DEFAULT_TEST_PERCENTAGE = 0.5;
export function runSplitTest({
  splitTest,
  randomNumber,
  threshold = DEFAULT_TEST_PERCENTAGE,
}: {
  splitTest: TAnonymousSplitTest;
  randomNumber: number;
  threshold?: number;
}): TBranch {
  const { branches, defaultBranch } = splitTest;

  if (randomNumber > threshold) {
    return { branchName: branches[0], testPercentage: threshold };
  }

  return {
    branchName: defaultBranch,
    testPercentage: 1 - threshold,
  };
}
